import { render, staticRenderFns } from "./BadgeTagList.vue?vue&type=template&id=663fa8de&"
import script from "./BadgeTagList.vue?vue&type=script&lang=js&"
export * from "./BadgeTagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports